import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from "react-i18next";

//import lib
import isEmpty from "../../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf";
import { toastAlert } from "../../lib/toastAlert";
import { calculateCompound, interestByDays } from "../../lib/calculation"

//import validation
import { StakingValidation } from "./Validation";

//import api
import { stakeLockedOrderPlace, stakeOrderPlace } from "../../api/staking";
import { getAssetData } from "../../api/walletAction";

const initialFormValue = {
    price: "",
}

const StakingModal = (props) => {
    // props
    const { isShow, record, onHide, type } = props;

    // redux
    const priceConversion = useSelector((state) => state.priceConversion);
    const account = useSelector((state) => state.account);




    //state
    const [formValue, setFormValue] = useState(initialFormValue)
    const { price } = formValue;
    const [intrest_per, setintrest_per] = useState();
    const [intrest, setInterest] = useState();
    const [interUSD, setInterUSD] = useState(0)
    const [durationdays, setdurationdays] = useState(0);;
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [USDValue, setUSD] = useState(0)

    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    //function
    const handleClick = () => {
        let formData = { ...formValue, ...{ ["price"]: record?.stakeBal } };
        setFormValue(formData);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == "price") {
            if (/[^0-9.]/.test(value)) return;
        }
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, 8) } }
        setFormValue(formData);
        if (!isEmpty(errors)) {
            setErrors({});
        }
        if (value) {
            setLoader(false)
        }
    }

    const durationloop = (durations, mainindex) => {
        let arr = [];
        // console.log(durations, 'durationsdurationsdurations')
        if (!isEmpty(durations) && durations.length > 0) {
            durations.map((duration, index, array) => {
                // console.log(duration, index, '000000000000000000', array)
                let months = parseInt(duration.days) / 30
                if (index == array.length - 1) {
                    arr.push(
                        <button type="button" class="daysLocked" id={"act_" + mainindex + index}
                            onClick={() => {
                                onClick_Days(duration, mainindex, index);
                            }}
                        >
                            {" "}
                            {toFixedDown(months, 2)} {t("MONTH")}
                        </button>
                    );
                } else {
                    arr.push(
                        <button type="button" class={`daysLocked ${index == 0 ? "active" : ""}`} id={"act_" + mainindex + index}
                            onClick={() => {
                                onClick_Days(duration, mainindex, index);
                            }}
                        >
                            {" "}
                            {toFixedDown(months, 2)} {t("MONTH")}
                        </button>
                    );
                }
            });

            return arr;
        }
    };


    const onClick_Days = (duration, index, inc) => {
        $(".daysLocked").removeClass("active");
        $("#act_" + index + inc).addClass("active");
        // console.log(duration, "durationdurationdurationduration");
        setintrest_per(duration.APY);
        // setintrest(toFixed((duration.days * interestByDays(1000, duration.APY, 365)), 4))
        // setindexval(index);
        setdurationdays(duration.days);
    };



    const handleSubmit = async () => {
        try {
            if (type === 'flexible') {
                setLoader(true)
                let reqData = {
                    price,
                    stakeId: record?._id,
                    type: type
                }
                let validationError = StakingValidation(reqData);
                if (!isEmpty(validationError)) {
                    setErrors(validationError);
                    setLoader(false);
                    return;
                }
                const { status, loading, message, il8 } = await stakeOrderPlace(reqData)
                setLoader(loading)
                if (status === true) {
                    setTimeout(() => {
                        setLoader(false);
                    }, 500)
                    toastAlert("success", t(message, il8), "login");
                    hanldeClose()
                } else {
                    setLoader(false);
                    toastAlert("error", t(message, il8), "login");
                }
            } else if (type === 'fixed') {
                setLoader(true)
                let reqData = {
                    price,
                    stakeId: record?._id,
                    type: type,
                    duration_days: !isEmpty(durationdays) ? durationdays : record && record.periodList[0] && record.periodList[0].days,
                    // isAutoRestake: !isEmpty(account?.isAutoRestake)?account?.isAutoRestake:"No"
                }
                let validationError = StakingValidation(reqData);
                if (!isEmpty(validationError)) {
                    setErrors(validationError);
                    setLoader(false);
                    return;
                }
                const { status, loading, message, il8 } = await stakeLockedOrderPlace(reqData)
                if (status === true) {
                    setTimeout(() => {
                        setLoader(false);
                    }, 500)
                    toastAlert("success", t(message, il8), "login");
                    hanldeClose()
                } else {
                    setLoader(false);
                    toastAlert("error", t(message, il8), "login");
                }
            }
        } catch (err) {
            setLoader(false);
            console.log(err, 'error')
        }
    }



    const hanldeClose = () => {
        onHide()
        setFormValue(initialFormValue)
        setInterUSD(0)
        setUSD(0)
        setErrors({})
    }


    function interestCal(Method, amount, currency, fixedAPY, activeDepositTerm, flexibleAPY) {
        if (Method === 'flexible') {
            let Value = interestByDays(amount, flexibleAPY, 365)
            setInterest(toFixedDown(Value, record?.decimal))
            let PriceCnv = priceConversion.find(
                (el) =>
                    el.baseSymbol == currency && el.convertSymbol == "USD"
            );
            setInterUSD(!isEmpty(PriceCnv?.convertPrice)
                ? parseFloat(Value) *
                parseFloat(PriceCnv.convertPrice)
                : parseFloat(Value))
        } else if (Method === 'fixed') {
            let Value;
            // if (account?.isAutoRestake == "Yes") {
            //     let maturity = calculateCompound(amount, fixedAPY, parseInt(activeDepositTerm))
            //     Value = maturity - amount
            //     setInterest(toFixedDown(Value, record?.decimal))
            // } else {
            //     Value = (parseInt(activeDepositTerm) * (interestByDays(amount, fixedAPY, 365)))
            //     setInterest(toFixedDown(Value, record?.decimal))
            // }
            Value = (parseInt(activeDepositTerm) * (interestByDays(amount, fixedAPY, 365)))
            setInterest(toFixedDown(Value, record?.decimal))
            let PriceCnv = priceConversion.find(
                (el) =>
                    el.baseSymbol == currency && el.convertSymbol == "USD"
            );
            let priceData = !isEmpty(PriceCnv?.convertPrice)
                ? parseFloat(Value) *
                parseFloat(PriceCnv.convertPrice)
                : parseFloat(Value)

            setInterUSD(toFixedDown(priceData, 4))
        }

        if (!isEmpty(price)) {
            let PriceCnv = priceConversion.find(
                (el) =>
                    el.baseSymbol == record?.coin && el.convertSymbol == "USD"
            );
            let ValueData = (!isEmpty(PriceCnv?.convertPrice)
                ? parseFloat(price) *
                parseFloat(PriceCnv.convertPrice)
                : parseFloat(price))
            setUSD(toFixedDown(ValueData, 4))
        } else if (isEmpty(price)) {
            setUSD(0)
        }

    }


    useEffect(() => {
        if (record) {
            if (type == 'fixed') {
                setdurationdays(record.periodList && record.periodList[0] && record.periodList[0].days)
                setintrest_per(record.periodList && record.periodList[0] && record.periodList[0].APY)
            }
        }
        getAssetData(dispatch)
    }, [isShow, record])


    useEffect(() => {
        interestCal(type, price, record?.coin, intrest_per, durationdays, record?.flexibleAPY)
    }, [type, price, record?.coin, intrest_per, durationdays, record?.flexibleAPY, priceConversion])



    return (
        <>
            <Modal
                show={isShow}
                onHide={hanldeClose}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Header className="justify-between"> 
                    <Modal.Title>
                        <h4 className="modal-title mt-0 model_head" >
                            {t("STAKING")}
                        </h4>
                    </Modal.Title>
                    <button type="button" className="border-0 bg-transparent p-0" aria-label="Close" onClick={hanldeClose}>
                        <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 0.9375C13.4528 0.9375 17.0625 4.54721 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.54721 17.0625 0.9375 13.4528 0.9375 9C0.9375 4.54721 4.54721 0.9375 9 0.9375ZM7.22315 6.16846C6.92858 5.9282 6.49432 5.94517 6.21973 6.21973C5.94523 6.49432 5.92822 6.9286 6.16846 7.22315L6.21973 7.28027L7.93943 9L6.22046 10.7198C5.92768 11.0126 5.92758 11.4874 6.22046 11.7802C6.51335 12.0729 6.98818 12.073 7.28101 11.7802L9 10.0606L10.719 11.7802L10.7762 11.8316C11.0706 12.0718 11.5049 12.0547 11.7796 11.7802C12.0541 11.5058 12.0716 11.0714 11.8316 10.7768L11.7796 10.7198L10.0598 9L11.7802 7.28027L11.8316 7.22315C12.0718 6.92859 12.0547 6.49432 11.7802 6.21973C11.5057 5.94517 11.0714 5.9282 10.7768 6.16846L10.7198 6.21973L9 7.93943L7.28027 6.21973L7.22315 6.16846Z" fill="#395645" />
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <form className="assets_form">
                        <div className="mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label for="withdrawamount" className="form-label">
                                    {t("AMOUNT")}
                                </label>
                                <label className="max_label" onClick={handleClick}>{t("MAX")}</label>
                            </div>
                            <div class="input-group">
                                <input
                                    type="text"
                                    class="form-control primary_asset_inp"
                                    placeholder="0.000000"
                                    name="price"
                                    value={price}
                                    onChange={handleChange}
                                />

                                <span
                                    class="primary_asset_inp"
                                >{record?.coin}</span>

                            </div>
                            <div class="form-text ms-3">≈ $ <CurrencyFormat displayType={'text'} thousandSeparator={true} value={USDValue} /></div>
                            <span
                                className='text-danger'
                            >{t(errors?.price)}</span>
                        </div>
                        <div className="deposit_asset_details">
                            <div>
                                <label>{t("INTEREST")}</label>
                                <label>{intrest ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={intrest} /> : 0} {record?.coin} <span>≈ $ {interUSD ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={toFixedDown(interUSD, 4)} /> : 0}</span></label>
                            </div>
                            <div>
                                <label>{t("AVAILABLE_BALANCE")}</label>
                                <label><CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(record?.stakeBal, 4)} /> {record?.coin} </label>
                            </div>
                            <div>
                                <label>{t("MINIMUM_STAKE")}</label>
                                <label><CurrencyFormat displayType={'text'} thousandSeparator={true} value={record.minimumAmount} /> {record?.coin}</label>
                            </div>
                            <div>
                                <label>{t("MAXIMUM_STAKE")}</label>
                                <label><CurrencyFormat displayType={'text'} thousandSeparator={true} value={record.maximumAmount} /> {record?.coin}</label>
                            </div>
                            <div>
                                <label>{t("WITHDRAWAL_TERM")}</label>
                                <label>{type === 'flexible' ? t("FLEXIBLE") : t("LOCKED_FOR") + durationdays / 30 + " " + t("MONTH")} </label>
                            </div>
                            {type != 'fixed' &&
                                <div>
                                    <label>{t("REDEMPTION_PERIOD")}</label>
                                    <label>{record.redemptionPeriod} {t("DAYS")}</label>
                                </div>
                            }
                            <div>
                                <label>{t("DURATION")}</label>
                                <label>{type === 'fixed' ? durationdays : 365} </label>
                            </div>
                            <div>
                                <label>{t("APY")}</label>
                                <label className="txt_green">{type === 'fixed' ? intrest_per : record?.flexibleAPY}%</label>
                            </div>
                            {type === 'fixed' &&
                                <div className="modal_staking_period">
                                    <label>{t("STAKING_PERIOD")}</label>
                                    <div class="staking_method_btngrp mb-3 mt-1">
                                        {durationloop(record?.periodList)}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="w-full inline-flex justify-start items-center gap-2 mt-4">
                            <button type="button"
                                className="flex-1 h-10 px-4 relative bg-gray-300 hover:bg-gray-400 active:bg-gray-500 active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0"
                                onClick={hanldeClose}
                            >
                                <div className="text-center justify-center text-[#395645] text-base font-medium font-['Roobert']">{t("CANCEL")}</div>
                            </button>
                            {
                                loader ?
                                    <button type="button" className="flex-1 h-10 px-4 relative bg-[#395645] rounded-sm flex justify-center items-center overflow-hidden border-0 opacity-70 cursor-not-allowed" disabled={true}>
                                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("LOADING")}...</div>
                                    </button> :
                                    <button type="button" onClick={handleSubmit} className="flex-1 h-10 px-4 relative bg-[#395645] hover:bg-[#2a4033] active:bg-[#1d2d24] active:scale-95 transition-all duration-200 rounded-sm flex justify-center items-center overflow-hidden border-0">
                                        <div className="text-center justify-center text-zinc-100 text-base font-medium font-['Roobert']">{t("CONFIRM")}</div>
                                    </button>
                            }
                        </div>

                    </form>
                </Modal.Body>
            </Modal>



        </>
    )
}


export default StakingModal;